import { render, staticRenderFns } from "./BigGreenNewButton.vue?vue&type=template&id=7a3b5872"
import script from "./BigGreenNewButton.vue?vue&type=script&lang=js"
export * from "./BigGreenNewButton.vue?vue&type=script&lang=js"
import style0 from "./BigGreenNewButton.vue?vue&type=style&index=0&id=7a3b5872&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports